import React, {useEffect} from "react";
import './AnalizaMain.css';
import zdj from './mojeZdjecie.jpg';
import * as AIIcons from 'react-icons/ai';

export default function Author(){

    useEffect(()=>{
        document.title="Strona o autorze";
    },[])

    return(
        <div className='conceptsContainer'>
            <h1>O MNIE</h1>
            <p>Nazywam się Ignacy Mermer</p>
            <p>Jestem uczniem drugiej klasy na profilu <b>matematyczno - fizyczno - informatycznym</b> w IX Liceum
                Ogólnokształcym im. C. K. Norwida w Częstochowie. Interesuję się szeroko pojętym
                programowaniem, począwszy od programowania stron internetowych i aplikacji, po tworzenie rzeczy
                backendowych w języku Java. Oprócz tego bardzo lubię matematykę i fizykę. W ostatnim czasie
                potrzebowałem analizy matematycznej m.in. do zadań z fizyki, więc stwierdziłem, że może być to ciekawy
                pomysł na stronę internetową i aplikację mobilną. Mam również nadzieję, że kalkulatory matematyczne w aplikaji
                mogą być wykorzystane przez uczniów w każdym wieku, do przyszpieszenia prostych obliczeń.
            </p>

            <h1>O STRONIE</h1>
            <p>Praca została przygotowana na konkurs "Zobaczyć matematykę", i jeśli będzie to dozwolone przez
                regulamin to będzie dalej rozwijana. Na początku planowałem stworzyć aplikację mobilną, która miałaby w
                sobie więcej kalkulatorów oraz mogła łączyć uczniów przez forum lub czat. Wszystko potoczyło się jednak inaczej
                i stwierdziłem, że jeśli stworzę stronę zawierającą analizę matematyczną, to przez prosty język, którym jest ona
                wytłumaczona, może być to bardziej pomocne dla mnie, jak i dla innych.</p>

            <p><img src={zdj} className='imageProf'/></p>
            <p className='oneLine'>
                <AIIcons.AiFillGithub className='ikonka' onClick={()=>{
                    window.location.href='https://github.com/IgnacyMermer2003';
                }}/>
                <AIIcons.AiFillFacebook className='ikonka' onClick={()=>{
                    window.location.href='https://www.facebook.com/profile.php?id=100007961356654';
                }}/>
                <AIIcons.AiOutlineTwitter className='ikonka' onClick={()=>{
                    window.location.href='https://twitter.com/IgnacyMermer';
                }}/>

            </p>
        </div>
    );
}